import { initializeIcons } from '@uifabric/icons';
import React from 'react';
import { AppContextProvider } from './AppContextProvider';
import { Layout } from './components/Layout/Layout';
import { HandleError } from './HandleError';
import Router from './Router';

initializeIcons();

const App = () => {

    return <AppContextProvider>
        <HandleError>
            <Layout>
                <Router />
            </Layout>
        </HandleError>
    </AppContextProvider>;

};

export default App;